import {
  isExperimentEnabled,
  activateExperiment,
  trackEvent
} from 'views/assets/scripts/optimizely'

import { AFTER_QUERY_SUGGEST_LAYER } from 'shared/experiments/consts'

import {
  SELECTOR_DESKTOP_INPUT,
  SELECTOR_MOBILE_SEARCH_ICON
} from 'views/containers/browser/SearchBoxContainer/consts'

const PRODUCT_CLICK_EVENT = 'Click on product in suggest'
const SUGGESTION_CLICK_EVENT = 'Click on query suggestions'
const SHOW_ALL_PRODUCT_EVENT = 'Click on show all'

export default () => {
  if (!isExperimentEnabled(AFTER_QUERY_SUGGEST_LAYER)) {
    return
  }

  const searchInputs = [
    document.querySelector(SELECTOR_DESKTOP_INPUT),
    document.querySelector(SELECTOR_MOBILE_SEARCH_ICON)
  ].filter(Boolean)

  const activate = () => {
    activateExperiment(AFTER_QUERY_SUGGEST_LAYER)

    searchInputs.forEach(input => {
      input.removeEventListener('click', activate)
    })
  }

  searchInputs.forEach(input => {
    input.addEventListener('click', activate)
  })

  document.addEventListener('click', event => {
    const { target } = event

    if (target.closest('[data-clientside-hook~="SearchBoxListItemLink"]')) {
      trackEvent(PRODUCT_CLICK_EVENT)
    }

    if (target.closest('[data-clientside-hook~="SearchBoxListSuggestLink"]')) {
      trackEvent(SUGGESTION_CLICK_EVENT)
    }

    if (target.closest('form[name~="search-results"]')) {
      trackEvent(SHOW_ALL_PRODUCT_EVENT)
    }
  })
}
